module.exports = __webpack_public_path__ + "img/checkbox-on.2288b5b2.svg";